import { FilterOptionValue } from '../quick-filter/generate-or-list-filter/generate-or-list-filter.interface';

/* eslint-disable @typescript-eslint/naming-convention */
export interface DataGridUrls {
    columnUrl?: string;
    dataUrl?: string;
    filterUrl?: string;
    dataUrlMethod?: string;
};

export enum dataUrlMethod {
    POST = 'POST',
    GET = 'GET'
}

export interface DataGridOptions {
    module: string;
    bulkActionIdColumn?: string;
    dynamicfilterheader?: string;
    paginate: {
        isEnabled: boolean;
        count?: number;
        position?: 'BOTTOM' | 'TOP';
    };
    fromDetailsPage?: boolean;
    dataSource?: any[];
    columns?: Array<GridColumn>;
    sort?: {
        sortBy?: string;
        sortDir?: string;
    };
    filter?: {
        savedFilter?: boolean;
        dataFilter?: boolean;
    };
    actionButtons?: {
        isEnabled?: boolean;
        displayName?: string;
        displayKey?: string | Array<any>;
        icon?: string;
        action?: string;
        children?: Array<ActionButtons>;
    };
    isTabsEnabled?: boolean;
    tabs?: Array<ActionButtons>;
    filterRules?: Array<FilterOptionValue>;
    showDateRange?: boolean;
    showModuleButtons?: boolean;
    modulesData?: Array<{
        icon?: string;
        count?: number;
        displayName: string;
        displayKey: string;
        showIf?: boolean;
    }>;
    allowExport?: boolean;
    columnReorder?: boolean;
    inlineSearch?: {
        isEnabled: boolean;
        displayKey: string;
    };
    bulkActions?: Array<{
        icon?: string;
        displayName: string;
        displayKey: string;
        key: string;
        showIf?: boolean;
    }>;
    displayRowActions?: boolean;
    rowActions?: Array<{
        icon: string;
        displayName: string;
        displayKey: string;
        key: string;
        showIf?: string;
    }>;
    emptySearchResultKey?: string;
    embed?: boolean;
};

export interface ActionButtons {
    displayName?: string;
    displayKey?: string | Array<any>;
    icon?: string;
    action?: string;
    type?: 'ERROR' | 'WARNING' | 'SUCCESS' | 'INFO'
}

export interface GridColumn {
    display_name: string;
    display_key: string;
    data_key: string;
    data_type?: string;
    field_type: string;
    checked: boolean;
    display_type: string;
    is_sortable: boolean;
    is_locked: boolean;
    allow_editing: boolean;
    combine_column?: string;
    combine_with?: string;
    redirect?: any;
    cellTemplate?: any;
    headerTemplate?: any;
    class?: string;
    style?: any;
}

export interface Pagination {
    pageIndex: number;
    pageSize: number;
    totalRecords: number;
};

export interface DefaultSortOptions {
    sortBy: string;
    sortDir: string;
};

export interface applicability {
    key: string;
    value: string;
}

export const serviceContractStatus = {
    AWAIT_APPROVAL: 'text.pending',
    ON_HOLD: 'text.on_hold',
    APPROVED: 'text.approved',
    REJECTED: 'text.rejected',
    AWAIT_CUSTOMER_APPROVAL: 'text.await_customer_approval',
    CUSTOMER_REJECTED: 'text.customer_rejected',
    CUSTOMER_APPROVED: 'text.customer_approved'
};

const assetStatus = {
    READY_TO_INSTALL : 'text.ready_to_install',
    INSTALLED : 'text.installed',
    UNDER_SERVICE : 'text.under_service',
    REMOVED  : 'text.removed',
    OBSOLETE : 'text.obsolete',
    ONLINE : 'text.online',
    OFFLINE : 'text.offline',
    NEED_REPAIR : 'text.needs_to_repair'
};

const estimateStatus = {
    DRAFT: 'text.draft',
    AWAIT_RESPONSE: 'text.sent',
    APPROVED: 'accepted.text',
    DECLINED: 'declined',
    ARCHIVED: 'text.archived',
    CLOSED: 'text.closed',
    CANCELED: 'text.canceled',
    REQUEST_CHANGE: 'text.change_requested',
};

const invoiceStatus = {
    DRAFT: 'text.draft',
    AWAIT_PAYMENT: 'text.sent',
    PAID: 'text.paid',
    PARTIALLY_PAID: 'text.partially_paid',
    BAD_DEBT: 'text.bad_debt',
    CANCELED: 'text.canceled',
    ARCHIVED: 'text.archived',
    CLOSED: 'text.closed'
};

export const Status = {
    COMPLETED: 'text.completed',
    ON_PROGRESS: 'status.on_progress',
    INITIATED: 'text.initiated',
    FAILED: 'text.failed',
    INPROGRESS: 'status.in_progress',
    DISPUTED:'text.disputed',
    PARTIALLY_REFUNDED: 'text.partially.refunded',
    REFUNDED:'status.financing.REFUNDED',
    invoice: invoiceStatus,
    estimate: estimateStatus,
    search_invoice: invoiceStatus,
    search_estimates: estimateStatus,
    assets: assetStatus,
    search_assets: assetStatus,
    service_contract: serviceContractStatus,
    search_service_contracts: serviceContractStatus,
    timesheet_approval: serviceContractStatus,
    payments: {
        SUCCESS: 'text.success',
        AWAIT_PAYMENT: 'text.processing',
        FAILED: 'text.failed',
        VOIDED: 'text.voided'
    },
    report_history: {
        FAILED: 'text.failed',
        COMPLETED: 'text.completed',
        INITIATED: 'text.initiated',
    },
    prequalification_financing: {
        INITIATED: 'text.initiated',
        PREQUALIFIED: 'status.financing.PREQUALIFIED',
        DECLINED: 'declined',
        EXPIRED: 'declined',
    },
    loan_application_financing: {
        'INITIATED': 'text.initiated',
        'AUTHORIZED': 'status.financing.AUTHORIZED',
        'LOAN TERMS ACCEPTED': 'status.financing.LOAN_TERMS_ACCEPTED',
        'LOAN CONFIRMED': 'status.financing.LOAN_CONFIRMED',
        'SETTLED': 'text.settled',
        'DECLINED': 'declined',
        'EXPIRED': 'expired',
        'CANCELED': 'text.canceled',
        'REFUNDED': 'status.financing.REFUNDED'
    },
    jobs: {
        'NEW': 'status.jobs.NEW',
        'SCHEDULED': 'status.jobs.SCHEDULED',
        'ON_MY_WAY': 'status.jobs.ON_MY_WAY',
        'STARTED': 'status.jobs.STARTED',
        'ON_HOLD': 'status.jobs.ON_HOLD',
        'COMPLETED': 'status.jobs.COMPLETED',
        'CANNOT_COMPLETE': 'status.jobs.CANNOT_COMPLETE',
        'CLOSED': 'status.jobs.CLOSED',
        'FAILED': 'status.jobs.FAILED',
        'OTHER': 'status.jobs.OTHER',
    }
};

export const redirectUrl = {
    EMPLOYEE: 'employees',
    JOB: 'jobs',
    RECURRING_JOB: 'jobs',
    CUSTOMER: 'customers',
    ORGANIZATION: 'organizations',
    PROPERTY: 'property',
    MAPS: 'maps',
    TIMESHEET: 'timesheets',
    PRODUCTS: 'products',
    PRODUCT: 'products',
    ESTIMATE: 'estimates',
    ESTIMATES: 'estimates',
    INVOICE: 'invoices',
    SERVICE_CONTRACTS: 'contracts',
    SERVICE_CONTRACT: 'contracts',
    ASSETS: 'asset_management',
    TIMESHEET_APPROVAL: 'timesheets/approvals',
    ADVANCED_ANALYTICS: 'advanced_analytics',
    REQUEST: 'request',
    PROJECT: 'projects',
    TRANSFER_ORDER: 'transfer_orders',
    PRICELIST: 'pricelists'
};

export const CompanyModuleName = {
    EMPLOYEE: 'USER',
    JOB: 'JOB',
    RECURRING_JOB: 'JOB',
    CUSTOMER: 'CUSTOMER',
    ORGANIZATION: 'ORGANIZATION',
    PROPERTY: 'PROPERTY',
    MAPS: 'MAPS',
    TIMESHEET: 'TIMESHEET',
    PRODUCTS: 'PRODUCTS',
    PRODUCT: 'PRODUCTS',
    ESTIMATE: 'ESTIMATES',
    ESTIMATES: 'ESTIMATES',
    INVOICE: 'INVOICE',
    SERVICE_CONTRACTS: 'SERVICE_CONTRACTS',
    SERVICE_CONTRACT: 'SERVICE_CONTRACTS',
    ASSETS: 'ASSETS',
    PAYMENTS: 'PAYMENTS',
    PREQUALIFICATION_FINANCING: 'PREQUALIFICATION_FINANCING',
    LOAN_APPLICATION_FINANCING: 'LOAN_APPLICATION_FINANCING',
    FINANCING: 'FINANCING',
    ADVANCED_ANALYTICS: 'ADVANCED_ANALYTICS',
    REQUEST: 'REQUEST',
    PROJECT: 'PROJECT',
    TRANSFER_ORDER: 'PRODUCTS',
    PRICELIST: 'PRODUCTS'
};

export const exportRedirectUrl = {
    EMPLOYEE: 'employee',
    JOB: 'job',
    CUSTOMER: 'customer',
    ORGANIZATION: 'organization',
    PRODUCTS: 'product',
    PRODUCT: 'product',
    ESTIMATE: 'estimate',
    INVOICE: 'invoice',
    SERVICE_CONTRACT: 'service_contract',
    ASSETS: 'assets',
    TIMESHEET: 'timesheet',
    REQUEST: 'request',
    PROJECT: 'projects',
    TRANSFER_ORDER: 'product',
    PRICELIST: 'product'
};

export const calendarModule = {
    CONFIRMED: 'confirmed',
    HOLD: 'hold',
    CONTINUE: 'continue',
    CALENDAR: 'calendar'
};

export const moduleList = ['EMPLOYEE', 'TEAMS' ,'JOB','CUSTOMER','ORGANIZATION','PRODUCTS', 'PRODUCT', 'PRODUCT_GROUPS', 'ESTIMATE','INVOICE','SERVICE_CONTRACTS','ASSETS','RECURRING_JOB','TIMESHEET', 'TIMESHEET_LOCATION', 'PAYMENTS','PREQUALIFICATION_FINANCING','LOAN_APPLICATION_FINANCING','FINANCING', 'PPM', 'PROPERTY', 'SERVICE_CONTRACT', 'SCHEDULED_REPORTS', 'REPORT_HISTORY', 'TIMESHEET_APPROVAL', 'ADVANCED_ANALYTICS', 'TIMESHEET_ENROLLMENT', 'REQUEST', 'PROJECT', 'PROJECT_ESTIMATES', 'PROJECT_INVOICE', 'PROJECT_JOB', 'TRANSFER_ORDER','PRICELIST'];

export const displayType = {
    BOOLEAN: 'boolean',
    DECIMAL: 'decimal',
    STRING: 'string',
    EMPLOYEE_NAME: 'employee_name',
    TAGS: 'tags',
    ASSET: 'asset',
    CONTRACT: 'contract',
    NAME_SMALL: 'name_small',
    ACTIVE_STATUS: 'active_status',
    STATUS: 'status',
    PRIORITY: 'priority',
    DATETIME: 'datetime',
    DATE: 'date',
    TIME: 'time',
    TIME_FORMAT: 'time_format',
    INDEXCOLUMN: 'indexColumn',
    COMBINEDCOLUMN: 'combinedColumn',
    CUSTOMTEMPLATE: 'CustomTemplate',
    TEAM_NAME: 'team_name',
    ORGANIZATION_ADDRESS: 'organization_address',
    LOGO: 'logo',
    PROPERTY_NAME: 'property_name',
    CUSTOMER: 'customer',
    JOB_TITLE: 'job_title',
    SCHEDULEDDATETIME: 'scheduledDatetime',
    JOB_NUMBER: 'job_number',
    EMPLOYEE_ASSIGNED: 'employee_assigned',
    PRODUCT_SERVICE: 'product_service',
    PRODUCT_NAME_COLUMN: 'product_name_column',
    PPM_NUMBER: 'ppm_number',
    AUTH_PIC: 'authPic',
    FILE: 'file',
    JOB_ADDRESS: 'job_address',
    CUSTOM_COMPONENT: 'custom_component',
    REQUEST_STATUS: 'request_status'
};
